<template>
  <div class="col-lg-6 col-xl-4">
    <div class="portlet portlet--project">
      <div class="portlet-head">
        <h3>Ewidencja</h3>
      </div>
      <div class="portlet-body">
        <table class="table table-list m-0" >
          <tbody>
            <tr>
              <th>Powierzchnia ścian:</th>
              <td class="text-right">{{calculations.walls.toFixed(2)}}</td>
            </tr>
            <tr>
              <th>Powierzchnia sufitu:</th>
              <td class="text-right">{{calculations.ceiling.toFixed(2)}}</td>
            </tr>
            <tr>
              <th>Powierzchnia tapet:</th>
              <td class="text-right">{{calculations.wallpaper.toFixed(2)}}</td>
            </tr>
            <tr>
              <th>Podwieszany sufit GK:</th>
              <td class="text-right">{{calculations.celling_gk.toFixed(2)}}</td>
            </tr>
            <tr>
              <th>Podwieszany sufit GKBI:</th>
              <td class="text-right">{{calculations.ceiling_gkbi.toFixed(2)}}</td>
            </tr>
            <tr>
              <th>Alternatywna izolacja w m2:</th>
              <td class="text-right">{{calculations.alternative_insulation.toFixed(2)}}</td>
            </tr>
            <tr>
              <th>Kafelki podłogowe w m2:</th>
              <td class="text-right">{{calculations.tiles_floor.toFixed(2)}}</td>
            </tr>
            <tr>
              <th>Kafelki ścienne w m2:</th>
              <td class="text-right">{{calculations.tiles_wall.toFixed(2)}}</td>
            </tr>
            <tr>
              <th>Długość cokołu:</th>
              <td class="text-right">{{calculations.plinth.toFixed(2)}}</td>
            </tr>
            <tr>
              <th>Fugi silikonowe:</th>
              <td class="text-right">{{calculations.silicone_joints.toFixed(2)}}</td>
            </tr>
            <tr>
              <th>Parkiet:</th>
              <td class="text-right">{{calculations.parquet.toFixed(2)}}</td>
            </tr>
            <tr>
              <th>Listwa przypodłogowa:</th>
              <td class="text-right">{{calculations.baseboard.toFixed(2)}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "MeasurementCalculations",
  data() {
    return {};
  },
  computed: {
    ...mapGetters("construction", ["calculations"]),

  },
  methods: {}
};
</script>